"use client";

import React from "react";
import "./Corporate_BoardRooms.css";

const Corporate_Boardroom = () => {
  const industries = [
    "Product Teams",
    "Strategy Teams",
    "Consulting Firms",
    "Growth & Marketing",
    "AI & Innovation Teams",
    "FinTech",
    "Startups",
    "Global Enterprises",
    "E-Commerce Brands",
    "Business Operations",
  ];

  return (
    <section className="corporate_boardroom">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-5 col-md-5 col-12">
            <div className="corporate_boardroom_content">
              <h2>
                From Corporate Boardrooms to{" "}
                <em>Emerging Startups</em>
              </h2>

              <p>
                Build the capabilities to lead products, drive growth, solve
                business challenges, and create impact across industries.
              </p>
            </div>
          </div>

          {/* RIGHT INDUSTRIES */}
          <div className="col-lg-7 col-md-7 col-12">
            <div className="corporate_boardroom_tags">
              {industries.map((industry, index) => (
                <span
                  className="corporate_boardroom_tag"
                  key={index}
                >
                  {industry}
                </span>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Corporate_Boardroom;